import { memo } from 'react';

const ManUsingComputer = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="320" height="161" fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#BEEFF3"
        d="M0 160C0 71.63 71.63 0 160 0s160 71.63 160 160H0Z"
      />
      <path
        fill="#392BA7"
        d="M171.319 20.9075c-.89-.1-1.76-.12-2.61-.09-1.55-1.62-3.72-2.63-6.14-2.63-4.7 0-8.51 3.81-8.51 8.51 0 .3.02.59.04.88-1.19 1.46-1.9 3.33-1.9 5.36 0 1.43.36 2.78.98 3.96-.02.59 0 1.19.03 1.8 0 .11.02.21.03.31.03-.06.07-.12.1-.17.06-.1.11-.19.17-.29l.36-.57c1.55 2.1 4.03 3.46 6.84 3.46 4.7 0 8.51-3.81 8.51-8.51 0-.3-.02-.59-.04-.88.07-.09.13-.18.2-.26 1.64 3.09 3.92 6.35 6.13 9.19l.22 1.5c-1.11 1.2-1.79 2.8-1.79 4.57 0 2.8 1.7 5.2 4.13 6.22l-.47.66c.34-.15.66-.31.99-.47.66.22 1.37.34 2.1.34 3.73 0 6.75-3.02 6.75-6.75 0-.5-.06-.98-.16-1.45 1.26-2.12 2.05-4.45 2.21-6.87.58-8.43-7.51-16.69-18.16-17.83l-.01.01Z"
      />
      <path
        fill="#EBAB7D"
        d="M175.949 26.6967c-6.32-3.47-15.36.33-22.21 8.63-.23.28-.45.56-.68.85l-.21.27c-.17.22-.33.44-.49.66-.07.1-.14.19-.21.29-.21.29-.41.58-.62.88-.02.02-.03.04-.05.07-.22.32-.43.65-.64.98-.06.09-.12.19-.18.29-.16.25-.31.51-.47.76-.06.1-.12.19-.17.29-.2.34-.4.69-.6 1.05 0 .01-.01.03-.02.04-.19.34-.37.69-.54 1.03l-.21.42c-.11.22-.21.43-.32.65-.08.17-.16.34-.24.5-.09.19-.17.37-.25.56l-.24.54c-.02.04-.03.08-.05.11-4.79 11.37-3.51 22.75 3.47 26.57 1.83 1 3.88 1.4 6.04 1.25 1.98-.13 4.04-.72 6.11-1.7l18.11-24.19-.23-.35c.53-.95.69-1.58.69-1.58 1.57-8.46-.43-15.91-5.81-18.86l.02-.01Z"
      />
      <path
        fill="#392BA7"
        d="m169.391 39.2556-6.512-3.76a.4608.4608 0 0 0-.629.1684l-.65 1.1258a.4603.4603 0 0 0 .169.6284l6.512 3.76c.22.127.502.0516.629-.1684l.65-1.1258a.4603.4603 0 0 0-.169-.6284Z"
      />
      <path
        fill="#C17742"
        d="M165.839 58.3575c1.22 0 2.21-.9895 2.21-2.21 0-1.2206-.99-2.21-2.21-2.21-1.221 0-2.21.9894-2.21 2.21 0 1.2205.989 2.21 2.21 2.21ZM154.44 52.827l-3.56-3.78c-.31-.33-.27-.86.09-1.14l7.37-5.7-3.9 10.62Z"
      />
      <path
        fill="#2F2725"
        d="M162.57 47.265c.729 0 1.32-.591 1.32-1.32 0-.729-.591-1.32-1.32-1.32-.729 0-1.32.591-1.32 1.32 0 .729.591 1.32 1.32 1.32Zm-10.871-2.6367c.729 0 1.32-.591 1.32-1.32 0-.729-.591-1.32-1.32-1.32-.729 0-1.32.591-1.32 1.32 0 .729.591 1.32 1.32 1.32Z"
      />
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth=".84"
        d="M162.57 49.9984c2.236 0 4.05-1.8132 4.05-4.05 0-2.2367-1.814-4.05-4.05-4.05-2.237 0-4.05 1.8133-4.05 4.05 0 2.2368 1.813 4.05 4.05 4.05Zm-12.332-3.6718c2.236 0 4.049-1.8133 4.049-4.05 0-2.2368-1.813-4.05-4.049-4.05-2.237 0-4.05 1.8132-4.05 4.05 0 2.2367 1.813 4.05 4.05 4.05Z"
      />
      <path
        fill="#392BA7"
        d="m156.693 34.567-7.518.5706a.4506.4506 0 0 0-.415.4827l.106 1.396a.4503.4503 0 0 0 .483.4147l7.518-.5706a.45.45 0 0 0 .415-.4828l-.106-1.396a.4502.4502 0 0 0-.483-.4146Zm19.016 1.9302-3.1 13.5 9.09-1.79 3.45-7.47-1.95-10.12-7.49 5.88Z"
      />
      <path
        fill="#EBAB7D"
        d="m177.468 53.4397-19.55 15.53.19 9.98c.06 2.37 4.33 4.27 9.59 4.26 5.23 0 9.48-1.91 9.57-4.26l.19-25.52.01.01Z"
      />
      <path
        stroke="#C17742"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M158.25 72.975c1.32-.26 4.26-1.02 6.14-1.95.1-.05.19-.1.29-.15"
      />
      <path
        stroke="#2F2725"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".84"
        d="M152.859 60.3956s3.73 1.96 6.8-1.88"
      />
      <path
        stroke="#fff"
        strokeMiterlimit="10"
        strokeWidth=".84"
        d="m166.547 45.168 11.08 1.16"
      />
      <path
        fill="#EBAB7D"
        d="M177.488 55.9378c2.812 0 5.09-2.2789 5.09-5.09 0-2.8111-2.278-5.09-5.09-5.09-2.811 0-5.09 2.2789-5.09 5.09 0 2.8111 2.279 5.09 5.09 5.09Z"
      />
      <path
        stroke="#883E28"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".84"
        d="m179.259 49.9675-1.59-.57s-.47-.15-.74-.06c-.29.1-.26.56-.03.94.94 1.51.6 2.22-.06 2.45"
      />
      <path
        fill="#392BA7"
        d="M176.457 23.8762c-1.32 0-2.54.38-3.58 1.03-1.23-1.6599-3.2-2.75-5.42-2.75-3.73 0-6.75 3.02-6.75 6.75s3.02 6.75 6.75 6.75c1.31 0 2.54-.38 3.58-1.03 1.23 1.66 3.2 2.7501 5.42 2.7501 3.73 0 6.75-3.0201 6.75-6.7501s-3.02-6.75-6.75-6.75Z"
      />
      <path
        stroke="#C17742"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="m179.259 49.9675-1.59-.57s-.47-.15-.74-.06c-.29.1-.26.56-.03.94.94 1.51.6 2.22-.06 2.45"
      />
      <path
        stroke="#582917"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.03"
        d="M152.859 60.3956s3.73 1.96 6.8-1.88"
      />
      <path fill="#EE399E" d="M207 165.188h-72l2.802-64h66.396l2.802 64Z" />
      <path
        fill="#EE399E"
        d="M208.99 94.9097c-4.4-8.59-14.4-10.83-19.45-12.64-1.46-.52-2.86-.96-4.15-1.34-1.54 4.88-8.33 8.56-16.48 8.56s-14.94-3.68-16.48-8.56c-1.3.37-2.69.82-4.15 1.34-5.05 1.8-10.84 4.54-15.6 8.6-4.92 4.2-11.11 17.7603-12.16 24.8003l19.72 2.66 77.03-3.02c-1.37-6.5-8.27-20.4003-8.27-20.4003h-.01Z"
      />
      <path
        fill="#EBAB7D"
        d="M138.59 148.937c4.04-1.28 14.98-4.48 17.37-4.48 5.05 0 12.02 1.85 17.49 3.1l6.34.82c1.4.25 2.21 2.94 1.81 6.07-.4 3.15-1.88 5.56-3.3 5.41h-.03l-8.21-1.07c-2.26.83-6.61 2.19-13.16-.95-2.5.62-4.9 1.43-7.64 2.05-1.66.38-4.96.28-5.13-1.31-2.52.56-3.57 1.08-4.79-.6-.39-.54-.36-1.48.09-1.86-1.39-.46-1.47-2.58.33-3.88-.58.02-1.16 0-1.62-.3-1.32-.87-.57-2.7.45-3.02v.02Z"
      />
      <path
        stroke="#C17742"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="1.01"
        d="m154.01 154.246-9.67 3.77m6.651-6.75-10.92 4.61m8.86-7.419-8.65 3.76"
      />
      <path
        fill="#EE399E"
        d="m178.4 164.538 45.07-3.8c3.65-.45 6.86-2.63 8.64-5.85 1.77-3.22 1.89-7.1.32-10.43l-23.44-49.5596-20.73 9.7996 16.66 35.22-28.49 5.08 1.97 19.52v.02Z"
      />
      <path
        stroke="#E60278"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".95"
        d="m201.73 140.328-25.25 3.16m25.52-7.301-9-21.999m-57.863 15.89 1.2-19.32"
      />
      <path
        fill="#fff"
        d="M148.759 160.738H83.2387c-.36 0-.68-.25-.76-.6l-10.11-41.89c-.3-1.24.64-2.42 1.91-2.42h63.1003c.91 0 1.7.62 1.91 1.5l10.24 42.44c.12.5-.26.97-.76.97h-.01Z"
      />
      <path
        fill="#DCE5F2"
        d="M107.538 144.896c2.916 0 5.28-2.364 5.28-5.28 0-2.916-2.364-5.28-5.28-5.28-2.916 0-5.28 2.364-5.28 5.28 0 2.916 2.364 5.28 5.28 5.28Z"
      />
      <path
        fill="#EE399E"
        d="M125.547 104.657c.98-6.4997 4.18-12.2197 8.74-16.0797 10.26-8.72 25.65-10.8 25.65-10.8h4.66l6.33.02h4.66s18.4 1.91 28.63 10.67c4.54 3.89 4.7 9.85 5.65 16.3597l-83.86-.16"
      />
      <path
        fill="#EE399E"
        d="m180.359 82.4347-25.64-.35.01-6.71 25.22-.07.41 7.13Z"
      />
      <path
        stroke="#E60278"
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth=".95"
        d="M158.84 76.8047v2.34m3.238-2.34v2.34m3.242-2.34v2.34m3.25-2.34v2.34m3.239-2.34v2.34m3.25-2.34v2.34"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h320v160.35H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(ManUsingComputer);
